import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { ORIENTATION } from './constants/orientation'
import { orientationPropType } from './prop-types/orientation-prop-type'

import styles from './slider.module.css'

const propTypes = {
    customSliderColorClassName: PropTypes.string,
    defaultValue: PropTypes.number,
    disabled: PropTypes.bool,
    max: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    orientation: orientationPropType,
    scaleMarking: PropTypes.bool,
    scaleMarks: PropTypes.number,
    step: PropTypes.number,
    tickMarks: PropTypes.number,
    trackClass: PropTypes.string,
    value: PropTypes.number,
    wrapperClassName: PropTypes.string,
    filled: PropTypes.bool
}

const defaultProps = {
    customSliderColorClassName: '',
    disabled: false,
    orientation: ORIENTATION.HORIZONTAL,
    trackClass: '',
    value: 0,
    wrapperClassName: ''
}

class Slider extends Component {
    constructor(props) {
        super(props)
        const value = props.value !== undefined ? props.value : props.defaultValue

        this.thumbWidth = 20
        this.state = {
            value,
            width: 0
        }
        this.onChange = this.onChange.bind(this)

        if (props.defaultValue) {
            console.warn('[DEPRECATED] The property defaultValue is deprecated. Please use instead value')
        }

        if (props.scaleMarks) {
            console.warn('[DEPRECATED] The property scaleMarks is deprecated. Please use instead tickMarks')
        }

        if (props.scaleMarking) {
            console.warn('[DEPRECATED] The property scaleMarking is deprecated. Please use instead tickMarks')
        }
    }

    componentDidMount() {
        if (this.sliderWrapper) {
            const sliderWidth = window.getComputedStyle(this.sliderWrapper, null).getPropertyValue('width')
            if (sliderWidth && sliderWidth !== this.state.width) {
                /* eslint-disable-next-line react/no-did-mount-set-state */
                this.setState({ width: parseInt(sliderWidth, 10) })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.value !== this.state.value) {
            this.setState({ value: nextProps.value })
        }
    }

    render() {
        const {
            customSliderColorClassName,
            disabled,
            filled,
            max,
            min,
            orientation,
            scaleMarking,
            scaleMarks,
            step,
            tickMarks,
            trackClass,
            wrapperClassName
        } = this.props

        const { value, width } = this.state
        const isVertical = orientation === ORIENTATION.VERTICAL

        // css classes
        const inputRangeClass = cx(styles['slider'], `t3sel-slider-${orientation}`, { [styles['disabled']]: disabled })
        const progressClass = cx(
            styles['track-progress'],
            customSliderColorClassName,
            { [styles['disabled']]: disabled },
            't3sel-track-progress'
        )

        const trackClassNames = cx(
            styles['track'],
            { [styles['disabled']]: disabled },
            { [styles['filled']]: filled },
            trackClass
        )

        const progressPercentage = this.getProgressPercentage(value)
        const progressStyle = {
            width: `${progressPercentage}%`
        }
        const sliderShell = cx(styles['slider-shell'], {
            [styles['slider-vertical']]: isVertical
        })
        // let ticksAmount = scaleMarks ? scaleMarks : tickMarks
        let ticksAmount = scaleMarks || tickMarks

        if (isNaN(ticksAmount) && scaleMarking) {
            ticksAmount = max - min + 1
        }

        return (
            <div
                className={cx(styles['slider-wrapper'], wrapperClassName, 't3sel-slider-wrapper')}
                ref={ref => {
                    this.sliderWrapper = ref
                }}
            >
                <div className={sliderShell}>
                    {this.tickMarksRenderer(ticksAmount, isVertical, width)}
                    <div className={trackClassNames}>
                        <input
                            type="range"
                            className={inputRangeClass}
                            onChange={this.onChange}
                            {...{ disabled, max, min, step, value }}
                        />
                        <div className={progressClass} style={progressStyle} />
                    </div>
                </div>
            </div>
        )
    }

    getProgressPercentage(value) {
        const { max, min } = this.props

        if (isNaN(value) || value <= min) {
            return 0
        } else if (value >= max) {
            return 100
        }

        const range = max - min
        const percentage = ((value - min) * 100) / range

        return Math.round(percentage)
    }

    tickMarksRenderer(numOfTicks, isVertical, width) {
        if (isNaN(numOfTicks) || isNaN(width) || width < 1 || numOfTicks < 1) {
            return null
        }
        const tickList = []

        if (numOfTicks > 1) {
            const tickGap = width / (numOfTicks - 1)
            const tickGapCorrectWidth = this.thumbWidth / (numOfTicks - 1)

            for (let i = 0; i < numOfTicks; i++) {
                let tickPos = tickGap * i
                if (tickPos < width / 2) {
                    tickPos += this.thumbWidth / 2 - i * tickGapCorrectWidth
                } else if (tickPos > width / 2) {
                    tickPos -= this.thumbWidth / 2
                    tickPos += (numOfTicks - 1 - i) * tickGapCorrectWidth

                    tickPos = tickPos > width - 1 ? width - 1 : tickPos
                }
                tickList.push(
                    <line key={`tick-at-xPos-${tickPos}`} x1={`${tickPos}px`} y1="0" x2={`${tickPos}px`} y2="16px" />
                )
            }
        }
        const svgShell = cx(styles['svg-shell'], {
            [styles['horizontal']]: !isVertical,
            [styles['vertical']]: isVertical
        })
        return (
            <svg className={cx(svgShell, 't3sel-svg-ticks-shell')} width="100%" height="16px">
                <g className={styles['tick']}>{tickList}</g>
            </svg>
        )
    }

    onChange(evt) {
        const { onChange } = this.props
        const value = parseFloat(evt.target.value)
        onChange(value)
        this.setState({ value })
    }
}

Slider.propTypes = propTypes
Slider.defaultProps = defaultProps

export { Slider }
